<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" class="text-h6 font-weight-bold">স্পউসের তালিকা</v-col>
      <v-col cols="6" class="text-end">
        <v-btn
          color="secondary"
          size="small"
          class="me-3 rounded-lg"
          @click="openModal"
        >
          <v-icon start>mdi-plus-circle-outline</v-icon> যোগ করুন
        </v-btn>
      </v-col>
      <v-col cols="12" md="12">
        <v-table class="language-table">
          <thead>
            <tr>
              <th>নাম</th>
              <th>এনাআইডি নম্বর</th>
              <th>জন্মতারিখ</th>
              <th>পাসপোর্ট নম্বর</th>
              <th>ই-টিন নম্বর</th>
              <th>নিজ জেলা</th>
              <th width="120">অ্যাকশন</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="SpouseData.length === 0">
              <td colspan="7" class="text-center py-6">কোন তথ্য পাওয়া যায়নি</td>
            </tr>
            <tr v-for="(item, index) in SpouseData" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.nid }}</td>
              <td>{{ item.birthdate }}</td>
              <td>{{ item.passport }}</td>
              <td>{{ item.tin }}</td>
              <td>{{ item.city }}</td>
              <td>
                <div class="d-flex align-center">
                  <v-btn
                    icon
                    size="small"
                    color="primary"
                    variant="text"
                    @click="editItem(item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    size="small"
                    color="red"
                    variant="text"
                    @click="removeLanguage(index)"
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>

    <form>
      <InsertModal ref="Modal" title="স্পউসের তথ্য" :width="900">
        <template #modalBody>
          <v-row>
            <!-- NID Type -->
            <v-col cols="12" md="12">
              <div class="mb-2 font-weight-medium">
                এনআইডি/স্মার্টকার্ড <span class="text-red">*</span>
              </div>

              <v-radio-group v-model="form.nid_type" inline hide-details>
                <v-radio label="এনআইডি" value="nid"></v-radio>
                <v-radio label="জন্মনিবন্ধন" value="birth"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.nid_number"
                label="এনআইডি নম্বর লিখুন"
                variant="outlined"
                density="comfortable"
              />
            </v-col>

            <!-- NID Copy -->
            <v-col cols="12" md="6">
              <v-file-input
                v-model="form.nid_copy"
                class="flex-grow-1"
                variant="outlined"
                rounded="lg"
                prepend-icon=""
                hide-details="auto"
                density="comfortable"
                label="এনআইডির কপি*"
                accept=".pdf,.jpg,.jpeg,.png"
                hint="সর্বোচ্চ সাইজ ৫ এমবি (ফরম্যাট: pdf, png, jpg, jpeg)"
                persistent-hint
                prepend-inner-icon="mdi-file"
              ></v-file-input>
            </v-col>

            <!-- DOB -->
            <v-col cols="12" md="6">
              <v-menu
                  v-model="dobMenu"
                  :close-on-content-click="false"
                  location="bottom"
              >
                <template #activator="{ props }">

                  <v-text-field
                      :model-value="formatDate(form.dob)"
                      label="জন্মতারিখ"
                      prepend-inner-icon="mdi-calendar"
                      variant="outlined"
                      density="comfortable"
                      readonly
                      v-bind="props"
                  />
                </template>
                <v-date-picker style="margin-top: -20px"
                               v-model="form.dob"
                               color="primary"
                               hide-header
                               @update:modelValue="dobMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="12" md="6"></v-col>

            <!-- Bangla Name -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.name_bn"
                label="নাম (বাংলা)"
                variant="outlined"
                density="comfortable"
                rounded="lg"
              />
            </v-col>

            <!-- English Name -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.name_en"
                label="নাম (ইংরেজি) *"
                variant="outlined"
                density="comfortable"
              />
            </v-col>
            <!-- Mobile -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.mobile"
                label="মোবাইল নম্বর"
                placeholder="01XXXXXXXXX"
                variant="outlined"
                density="comfortable"
                rounded="lg"
              >
                <template #prepend-inner>
                  <span class="mr-2">+88</span>
                </template>
              </v-text-field>
            </v-col>

            <!-- Email -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.email"
                label="ই-মেইল"
                placeholder="example@gems.gov.bd"
                variant="outlined"
                density="comfortable"
                rounded="lg"
              />
            </v-col>

            <!-- Passport -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.passport"
                label="পাসপোর্ট নম্বর"
                placeholder="পাসপোর্ট নম্বর"
                variant="outlined"
                density="comfortable"
                rounded="lg"
              />
            </v-col>

            <!-- Passport Copy -->
            <v-col cols="12" md="6">
              <v-file-input
                v-model="form.passport_copy"
                class="flex-grow-1"
                variant="outlined"
                rounded="lg"
                prepend-icon=""
                hide-details="auto"
                density="comfortable"
                label="পাসপোর্ট কপি *"
                accept=".pdf,.jpg,.jpeg,.png"
                hint="সর্বোচ্চ সাইজ ৫ এমবি (ফরম্যাট: pdf, png, jpg, jpeg)"
                persistent-hint
                prepend-inner-icon="mdi-file"
              ></v-file-input>
            </v-col>

            <!-- E-TIN -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.etin"
                label="ই-টিন নম্বর"
                placeholder="ই-টিন নম্বর"
                variant="outlined"
                density="comfortable"
                rounded="lg"
              />
            </v-col>

            <!-- E-TIN Copy -->
            <v-col cols="12" md="6">
              <v-file-input
                v-model="form.passport_copy"
                class="flex-grow-1"
                variant="outlined"
                rounded="lg"
                prepend-icon=""
                hide-details="auto"
                density="comfortable"
                label="ই-টিন কপি *"
                accept=".pdf,.jpg,.jpeg,.png"
                hint="সর্বোচ্চ সাইজ ৫ এমবি (ফরম্যাট: pdf, png, jpg, jpeg)"
                persistent-hint
                prepend-inner-icon="mdi-file"
              ></v-file-input>
            </v-col>

            <!-- District -->
            <v-col cols="12" md="6">
              <v-select
                v-model="form.district"
                :items="districts"
                label="নিজ জেলা *"
                placeholder="নিজ জেলা বাছাই করুন"
                variant="outlined"
                density="comfortable"
                rounded="lg"
              />
            </v-col>

            <!-- Job Type -->
            <v-col cols="12" md="6">
              <v-select
                v-model="form.job_type"
                :items="jobTypes"
                label="চাকরির ধরন"
                placeholder="চাকরির ধরন বাছাই করুন"
                variant="outlined"
                density="comfortable"
                rounded="lg"
              />
            </v-col>

            <!-- Relation -->
            <v-col cols="12" md="6">
              <v-select
                v-model="form.relation"
                :items="relations"
                label="অবস্থা *"
                variant="outlined"
                density="comfortable"
                rounded="lg"
              />
            </v-col>

            <!-- Approval -->
            <v-col cols="12" md="6">
              <v-file-input
                v-model="form.passport_copy"
                class="flex-grow-1"
                variant="outlined"
                rounded="lg"
                prepend-icon=""
                hide-details="auto"
                density="comfortable"
                label="অবহিত প্রমাণ পত্র আপলোড করুন *"
                accept=".pdf,.jpg,.jpeg,.png"
                hint="সর্বোচ্চ সাইজ ৫ এমবি (ফরম্যাট: pdf, png, jpg, jpeg)"
                persistent-hint
                prepend-inner-icon="mdi-paperclip"
              ></v-file-input>
            </v-col>

            <!-- Special Note -->
            <v-col cols="12">
              <v-file-input
                v-model="form.passport_copy"
                class="flex-grow-1"
                variant="outlined"
                rounded="lg"
                prepend-icon=""
                hide-details="auto"
                density="comfortable"
                label="বিবােহর প্রমাণক"
                accept=".pdf,.jpg,.jpeg,.png"
                hint=" সকল তথ্য স্ক্যান করে পিডিএফ আকারে সংযুক্ত করুন। সর্বোচ্চ
              সাইজ ১৫ এমবি"
                persistent-hint
                prepend-inner-icon="mdi-paperclip"
              ></v-file-input>
            </v-col>
          </v-row>
        </template>
        <template #modalFooter>
          <v-row>
            <v-col cols="12">
              <v-btn
                color="primary"
                size="large"
                class="me-3 rounded-lg"
                type="submit"
              >
                <v-icon start>mdi-content-save-outline</v-icon>সংরক্ষণ করুন
              </v-btn>
              <v-btn
                color="grey-darken-1"
                variant="outlined"
                size="large"
                class="rounded-lg"
                @click="resetForm"
              >
                <v-icon start>mdi-refresh</v-icon>রিসেট
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </InsertModal>
    </form>
  </v-container>
</template>

<script>
import InsertModal from "@/components/shared/InsertModal.vue";

export default {
  name: "SpouseComponent",
  components: { InsertModal },

  data() {
    return {
      tab: 1,
      drawer: true,
      dobMenu: false,

      SpouseData: [
        {
          name: "Farjana",
          nid: "12045789",
          birthdate: "12 October 1990",
          passport: "A9874628",
          tin: "965874321",
          city: "Dhaka",
        },
        {
          name: "Lamiya Akter",
          nid: "96358742",
          birthdate: "10 May 1995",
          passport: "A65892345",
          tin: "951357465",
          city: "Chittagong",
        },
      ],

      districts: ["ঢাকা", "চট্টগ্রাম", "রাজশাহী", "খুলনা", "বরিশাল"],

      jobTypes: ["সরকারি", "বেসরকারি", "ব্যবসা", "ফ্রিল্যান্স"],

      relations: ["বিবাহিত", "অবিবাহিত", "ডিভোর্স"],

      form: {
        nid_type: "nid",
        nid_number: "",
        nid_copy: null,
        dob: "",
        name_bn: "",
        name_en: "",
        mobile: "",
        email: "",
        passport: "",
        passport_copy: null,
        etin: "",
        etin_copy: null,
        district: null,
        job_type: null,
        relation: null,
        approval_copy: null,
        special_note: null,
      },
    };
  },

  methods: {
    openModal() {
      this.$refs.Modal.openModal();
    },
    submitForm() {
      console.log(this.form);
    },

    resetForm() {
      this.form = {
        nid_type: "nid",
        nid_number: "",
        nid_copy: null,
        dob: "",
        name_bn: "",
        name_en: "",
        mobile: "",
        email: "",
        passport: "",
        passport_copy: null,
        etin: "",
        etin_copy: null,
        district: "",
        job_type: "",
        relation: "",
        approval_copy: null,
        special_note: null,
      };
    },
    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();

      return `${day}-${month}-${year}`;
    },
  },
};
</script>

<style scoped>
.empty-box {
  height: 350px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
}

.custom-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
}

:deep(.v-field) {
  border-radius: 10px !important;
}

:deep(.v-selection-control-group) {
  gap: 20px;
}

.text-red {
  color: red;
}

.v-navigation-drawer {
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.section-title {
  font-size: 18px;
  font-weight: 700;
  color: rgb(var(--v-theme-secondary));
}

.v-tab {
  text-transform: none !important;
  font-size: 14px;
}

.v-window-item {
  animation: fadeSlide 0.35s ease;
}

/* Smooth Animation */
@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
